import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=58461a88&scoped=true"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"
import style0 from "./OrderHistory.vue?vue&type=style&index=0&id=58461a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58461a88",
  null
  
)

export default component.exports